import { Component, OnInit } from '@angular/core';
import { ApiService } from "../services/api.service";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnInit {

  constructor(
    public api:ApiService
  ) { }

  ngOnInit() {
  }

  ionViewWillEnter(){
    this.api.title = "Dashboard"
    this.api.showTitle = false; setTimeout(() => { this.api.showTitle = true; }, this.api.timeShowTitle); //animación
  }

}
